<template>
  <div>
    <div class="message">
      <div class="message-header is-radiusless" @click="$emit('toggle')">
        <a class="button is-dark is-small">
          <span v-if="hidden" class="is-size-7"><fa-icon icon="angle-down"/></span>
          <span v-else class="is-size-7"><fa-icon icon="angle-right"/></span>
        </a>
        <p>{{unixToMonthYear(date)}}</p>
      </div>
      <div class="message-body" :class="hidden? '': 'hidden'">
        <table class="table level level-item">
          <tbody>
            <tr v-for="(order, idx) in orders" :key="idx">
              <th class="has-text-link">
                <router-link :to="`/customers/${order.customer_id}/orders/${order.order_id}`" >
                  {{order.order_id}}
                </router-link>
              </th>
              <td>{{order.po_sm}}</td>
              <td>{{displayCategory(order)}}</td>
              <td class="has-text-link"><a v-if="order.box_report" :href="`https://api.elitedecorinc.com/api/v1/orders/${order.order_id}/files?type=BoxReport&format=pdf&authToken=${authToken}`" target="_blank">Box Report</a></td>
              <td class="has-text-link"><a v-if="order.packing_slip" :href="`https://api.elitedecorinc.com/api/v1/orders/${order.order_id}/files?type=PackingSlip&format=pdf&authToken=${authToken}`" target="_blank">Packing Slip</a></td>
              <td class="has-text-link"><a v-if="order.signed_packing_slip" :href="`https://api.elitedecorinc.com/api/v1/orders/${order.order_id}/files?type=Signed&format=pdf&authToken=${authToken}`" target="_blank">Proof of Delivery</a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { fileByOrder } from '@/utils/api';

export default {
  props: ['orders', 'date', 'hidden'],
  updated() {
    this.$nextTick(() => { this.isHidden = this.hidden; });
  },
  data() {
    return {
      isHidden: this.hidden,
    };
  },
  methods: {
    unixToMonthYear(date) {
      return moment.unix(date).format('MMMM YYYY');
    },
    async getFile(orderId, type) {
      try {
        const response = await fileByOrder(orderId, type, 'pdf');
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'file.pdf');
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        console.error('an err', err);
      }
    },
    displayCategory(order) {
      return order.category === 'fab shades' ? 'Roman Shades' : order.category.replace(/^\w/, c => c.toUpperCase());
    },
  },
  computed: {
    authToken() {
      return encodeURIComponent(localStorage.getItem('ed-authToken'));
    },
    toggleIcon() {
      return this.isHidden ? 'fa-angle-right' : 'fa-angle-down';
    },
  },
};
</script>

<style scoped>
.message-header {
  justify-content: flex-start;
}
.message-header > p {
  margin-left: 1em;
}
.button {
  border-radius: 9999px;
}
.hidden {
  display: none;
}
.table {
  background-color: transparent;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: .3em solid transparent;
  border-right: .3em solid transparent;
  border-top: .5em solid whitesmoke;
}

.arrow-right {
  width: 0;
  height: 0;
  border-top: .3em solid transparent;
  border-bottom: .3em solid transparent;
  border-left: .5em solid whitesmoke;
}
</style>
